import React from "react";

// This is no longer a "Card" but a simple info block
const ProfileInfoCard = ({ user }) => {
  if (!user) return null;

  return (
    // ✨ Removed Card styles and negative margin. Added padding.
    <div className="flex flex-col items-center text-center py-6">
      <img
        src={user.profilePictureUrl}
        alt={user.fullName}
        className="w-20 h-20 rounded-full object-cover mb-3 shadow-md"
      />
      <h2 className="text-xl font-bold text-slate-800">{user.fullName}</h2>
      <p className="text-sm text-slate-500">@{user.username}</p>
    </div>
  );
};

export default ProfileInfoCard;
